import React, { memo } from "react";

import { ShowcaseCard } from "ui/components/Showcase";

/** Visine stupaca troškova po mjesecima (postotak visine grafa). */
const EXPENSE_BARS = [45, 70, 35, 85, 55, 65];

const SERVICE_ITEMS = ["Zamjena ulja i filtera", "Provjera kočnica"];

/** Slajd "Servisi i troškovi": termin servisa, graf troškova i podsjetnik za gume. */
const ServiceSlide: React.FC = () => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-0 w-[17rem]" delay={0}>
        <div className="p-5">
          <div className="flex items-center gap-3">
            <div className="flex flex-col items-center justify-center w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 text-white flex-shrink-0">
              <span className="text-lg font-bold leading-none">24</span>
              <span className="text-[0.6rem] font-semibold uppercase">Ruj</span>
            </div>
            <div>
              <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Idući servis</div>
              <div className="text-sm font-bold text-slate-800">Mali servis</div>
              <div className="text-[0.65rem] text-slate-400">Autoservis Horvat · 09:00</div>
            </div>
          </div>

          <div className="mt-4 flex items-center gap-3 rounded-md bg-slate-50 p-2">
            <div className="flex items-center justify-center w-16 h-10 rounded-sm bg-gradient-to-br from-amber-200 to-amber-300 overflow-hidden">
              <img src="/media/images/vehicles/vehicle-3.png" alt="" className="w-16" />
            </div>
            <div>
              <div className="text-[0.7rem] font-semibold text-slate-700">Kia Sorento</div>
              <div className="text-[0.65rem] text-slate-400">ZG 1234 AB · 84.320 km</div>
            </div>
          </div>

          <div className="mt-4 space-y-2">
            {SERVICE_ITEMS.map((item) => (
              <div key={item} className="flex items-center gap-2">
                <span className="flex items-center justify-center w-4 h-4 rounded-full bg-emerald-100">
                  <svg className="w-2.5 h-2.5" viewBox="0 0 12 12" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M2.5 6.5l2.5 2.5 4.5-5" />
                  </svg>
                </span>
                <span className="text-[0.7rem] text-slate-600">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-slate-800">Troškovi</span>
            <span className="text-[0.65rem] text-slate-400">zadnjih 6 mj.</span>
          </div>
          <div className="mt-1 text-lg font-bold text-slate-800">3.840,00 €</div>
          <div className="mt-3 flex items-end gap-2 h-20">
            {EXPENSE_BARS.map((height, index) => (
              <div
                key={index}
                className="flex-1 rounded-t-sm bg-gradient-to-t from-blue-500 to-sky-400 origin-bottom animate-growUp"
                style={{ height: `${height}%`, animationDelay: `${0.5 + index * 0.08}s` }}
              />
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <div className="flex items-center gap-3 px-4 py-3.5">
          <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-slate-50 flex-shrink-0 overflow-hidden">
            <img src="/media/images/vehicles/tires.webp" alt="" className="w-8 h-8 object-contain mix-blend-multiply" />
          </span>
          <div>
            <div className="text-[0.7rem] font-bold text-slate-800">Zamjena guma</div>
            <div className="text-[0.65rem] text-slate-400">ZG 1234 AB · za 5 dana</div>
          </div>
        </div>
      </ShowcaseCard>
    </>
  );
};

export default memo(ServiceSlide);
